module.exports = __webpack_public_path__ + "static/media/icita2005.4799e5a4.png";